import { create } from "zustand";

interface HookProps {
  my: {
    month: number;
    year: number;
  };
  setMY: (newMy: { month: number; year: number }) => void;
}

export const useMYPicker = create<HookProps>()((set) => ({
  my: {
    month: new Date().getMonth(),
    year: new Date().getFullYear(),
  },

  setMY: (newMy) =>
    set(() => ({
      my: newMy,
    })),
}));
